import { Form } from 'antd';
import dayjs from 'dayjs';

import type { ModelProductsTransfer } from '@app/api/Products';
import {
  useGoodsTransfer,
  useWarehouseSourceOperationEffects,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/hooks';
import {
  AddAvailableProductsModal,
  AvailableProductsSection,
  OperationCommentField,
  OperationDateField,
  OperationFormButtons,
  OperationWarehouseSelect,
} from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/ui';
import { toOperationDateTime } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/utils';

export const GoodsTransfer = () => {
  const {
    form,
    onFinish,
    isPageLoading,
    getWarehouseProductsForSelectionHandler,
    warehousesFromOptions,
    warehousesToOptions,
    warehouseProducts,
    isOpenAddAvailableProductsModal,
    onCloseAddAvailableProductsModal,
    onOpenAddAvailableProductsModal,
    onAdd,
    suppliersOptions,
    selectedProducts,
    products,
    formValues,
    totalCount,
    onDelete,
    setSelectedProducts,
    isProductsLoading,
    isLoadingTransferProducts,
    warehousesOptions,
  } = useGoodsTransfer();

  useWarehouseSourceOperationEffects({
    getWarehouseProductsForSelectionHandler,
  });

  return (
    <>
      <Form<ModelProductsTransfer>
        form={form}
        className="product-operation-form"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 5 }}
        labelAlign="left"
        disabled={isPageLoading || isLoadingTransferProducts}
        initialValues={{
          DateTransfer: toOperationDateTime(dayjs()),
          WarehouseFromId: undefined,
          WarehouseToId: undefined,
          Comment: '',
          Products: [],
        }}
        onFinish={onFinish}
      >
        <OperationDateField name="DateTransfer" />
        <OperationWarehouseSelect
          name="WarehouseFromId"
          label="Со склада"
          options={warehousesFromOptions}
          onChange={() => {
            form.setFieldsValue({ Products: [] });
            setSelectedProducts([]);
          }}
        />
        <OperationWarehouseSelect
          name="WarehouseToId"
          label="На склад"
          options={warehousesToOptions}
        />
        <AvailableProductsSection
          form={form}
          products={products}
          warehouseProducts={warehouseProducts}
          onDelete={onDelete}
          isAddDisabled={!formValues?.WarehouseFromId}
          isPageLoading={isPageLoading}
          isMutationLoading={isLoadingTransferProducts}
          onOpenModal={onOpenAddAvailableProductsModal}
          totalCount={totalCount}
        />
        <OperationCommentField />
        <OperationFormButtons
          submitLabel="Принять"
          isLoading={isLoadingTransferProducts}
          onReset={() => form.resetFields()}
        />
      </Form>
      <AddAvailableProductsModal
        isOpen={isOpenAddAvailableProductsModal}
        onClose={onCloseAddAvailableProductsModal}
        onAdd={onAdd}
        productList={products || []}
        suppliersOptions={suppliersOptions}
        warehousesOptions={warehousesOptions}
        selectedProducts={selectedProducts}
        warehouseProducts={warehouseProducts}
        isLoading={isProductsLoading}
      />
    </>
  );
};
